import {
  createRouter,
  createWebHistory
} from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import List from '../views/List.vue'
import Detail from '../views/Detail.vue'
import About from '../views/About.vue'

const routes = [{
    // 登录
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    // 首页
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    // 列表页
    path: '/list/:id',
    name: 'List',
    component: List
  },
  {
    // 详情页
    path: '/detail/:id',
    name: 'Detail',
    component: Detail
  },
  {
    // 关于页
    path: '/about',
    name: 'About',
    component: About
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router